module.exports = __webpack_public_path__ + "img/my_moren@3x.5248fab5.png";